<template>
  <v-container>
    <v-row align="stretch" justify="center">
      <v-col
        v-for="card in cards"
        :cols="isMobile ? 12 : 12 / cards.length"
        :key="card.text"
      >
        <step-card :arrow="card.arrow" :icon="card.icon" :type="card.type">
          <template slot="text">
            <span v-html="card.text"></span>
          </template>
        </step-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="form-card mx-auto text-center">
          <v-alert outlined :type="responseStatus" text v-if="isDone || isSent">
            {{ formMessage }}
          </v-alert>
          <template v-if="!isDone">
            <v-form ref="form">
              <v-row justify="space-around">
                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    label="Фамилия"
                    v-model="fields.lastName"
                    :rules="[rules.required, rules.cyrillic]"
                    @input.native="filterInput"
                    name="lastName"
                  />
                </v-col>
                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    label="Имя"
                    v-model="fields.firstName"
                    :rules="[rules.required, rules.cyrillic]"
                    @input.native="filterInput"
                    name="firstName"
                  />
                </v-col>
                <v-col :cols="isMobile ? 12 : 4">
                  <v-text-field
                    label="Отчество"
                    v-model="fields.patronymic"
                    :rules="[rules.required, rules.cyrillic]"
                    @input.native="filterInput"
                    name="patronymic"
                  />
                </v-col>
                <v-col :cols="isMobile ? 12 : 3">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Дата рождения"
                        :rules="[rules.required, rules.date]"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="datePicker"
                      v-model="fields.birthDate"
                      no-title
                      @input="dateMenu = false"
                      locale="ru-ru"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col :cols="isMobile ? 12 : 3">
                  <v-text-field
                    label="E-mail"
                    v-model="fields.email"
                    :rules="[rules.required, rules.email]"
                /></v-col>
                <v-col :cols="isMobile ? 12 : 3">
                  <v-text-field
                    label="Мобильный телефон"
                    v-model="fields.phone"
                    type="tel"
                    v-mask="'+7(###)###-##-##'"
                    :rules="[rules.required, rules.phone]"
                /></v-col>
                <v-col :cols="isMobile ? 12 : 3">
                  <v-text-field
                    v-if="codeReceived"
                    label="Код из СМС"
                    v-model="fields.sms_code"
                    v-mask="'####'"
                    :rules="[rules.required, rules.code]"
                  />
                  <v-btn
                    v-else
                    class="code-button"
                    :loading="isGettingCode"
                    @click="getCode"
                    >Получить код по СМС</v-btn
                  >
                </v-col>
              </v-row>
              <v-row align="stretch" justify="center">
                <v-col cols="12" class="captcha-wrapper">
                  <vue-recaptcha
                    :sitekey="this.captchaKey"
                    @verify="verifyCaptcha"
                  ></vue-recaptcha>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    class="submit-button"
                    :loading="isLoading"
                    @click="submit"
                    >Получить электронную Карту МЕТРО</v-btn
                  >
                  <p class="pers-data__title">
                    Нажимая кнопку "Получить карту" я даю своё согласие на
                    <a
                      class="pers-data__link"
                      @click="togglePersDataProcessingText"
                      >обработку персональных данных</a
                    >
                  </p>
                  <p
                    class="pers-data__text"
                    v-if="shouldShowPersDataProcessing"
                  >
                    Настоящим я даю своё согласие
                    ООО&nbsp;«МЕТРО&nbsp;Кэш&nbsp;энд&nbsp;Керри» (далее –
                    «МЕТРО») – оператору персональных данных,
                    зарегистрированному по адресу: 125445, г.&nbsp;Москва,
                    Ленинградское&nbsp;ш.&nbsp;71Г, на обработку моих
                    персональных данных (далее – ПД), указанных в настоящей
                    форме, а также иных персональных данных, ставших известными
                    МЕТРО в соответствии с требованиями Федерального закона
                    №&nbsp;152-ФЗ от 27.07.2006&nbsp;г. «О&nbsp;персональных
                    данных». ПД предоставляются для следующих целей: получение
                    карты клиента МЕТРО, для продвижения представленных к
                    продаже товаров, работ, услуг; для проведения клиентских
                    маркетинговых исследований; для дистанционной торговли.
                    Настоящее согласие предоставляется на осуществление
                    следующих действий в отношении моих ПД: сбор,
                    систематизацию, накопление, хранение, обновление, изменение,
                    использование, обезличивание, шифрование, блокирование,
                    уничтожение, трансграничную передачу. Срок действия согласия
                    и срок обработки ПД: 3 года с даты подписания настоящей
                    формы; указанный срок продлевается в случае заключения
                    договора на период действия договора и 3-летний период после
                    его прекращения.
                  </p>
                  <v-checkbox
                    class="adv-checkbox"
                    v-model="fields.canAdvertise"
                    :rules="[rules.required]"
                    :label="`
    Даю согласие на получение рекламных сообщений по указанным в настоящей анкете данным
    (в том числе о проводимых акциях, мероприятиях,
      специальных предложениях, для проведения маркетинговых исследований).
      `"
      ></v-checkbox>     
      <a class="details__title" @click="toggleSmsDetailsText">Подробнее об SMS услуге</a>
      <p class="details__text" v-if="shouldShowSmsDetails">
        Стоимость отправки СМС на номер 9395: МегаФон-1,77&nbsp;р., Билайн-1,70&nbsp;р., МТС-2,00&nbsp;р., Tele2-1,73&nbsp;р. (с учетом НДС).
        Подробнее с актуальными ценами на услугу отправки SMS на короткие сервисные номера можно уточнить у Вашего мобильного оператора.
        Денежные средства за отправленные SMS не возмещаются, абонент самостоятельно принимает решение о продолжении оформления карты МЕТРО, в случае отказа от регистрации карты МЕТРО денежные средства не возвращаются.
      </p>
    </v-col>
  </v-row>
</v-form>
</template>
</v-card>
</v-col>
</v-row>
</v-container>
</template>

<script>
import StepCard from "./StepCard";
import { PATTERNS, MESSAGES, STATUSES } from "../constants";
import { VueRecaptcha } from "vue-recaptcha";

import arrow from "../assets/arrow.svg";
import tick from "../assets/icon1.svg";
import card from "../assets/icon2.svg";
import metro from "../assets/icon3.svg";

export default {
  name: "RegisterForm",
  components: { "step-card": StepCard, VueRecaptcha },
  data() {
    return {
      isMobile: false,
      shouldShowPersDataProcessing: false,
      shouldShowSmsDetails: false,
      shouldShowCashbackDetails: false,
      shouldShowGuestCardUsageDetails: false,
      isDone: false,
      isSent: false,
      isLoading: false,
      isGettingCode: false,
      codeReceived: false,
      responseStatus: null,
      formMessage: "",
      dateMenu: false,
      captchaKey: process.env.VUE_APP_CAPTCHA_KEY,
      fields: {
        email: "",
        phone: "+7(",
        firstName: "",
        lastName: "",
        patronymic: "",
        sms_code: "",
        recaptcha_response: "",
        birthDate: new Date(new Date().getTime() - 568025136000)
          .toISOString()
          .substr(0, 10),
        birthDateFormatted: (vm) =>
          vm.formatDate(new Date().toISOString().substr(0, 10)),
        canAdvertise: false,
      },
      rules: {
        required: (value) => (value ? true : "Поле обязательно"),
        cyrillic: (value) =>
          PATTERNS.CYRILLIC.test(value) || "Только русские буквы",
        email: (value) =>
          value && (PATTERNS.EMAIL.test(value) || "Неверный e-mail"),
        phone: (value) => value.length === 16 || "Номер неверный",
        code: (value) => PATTERNS.CODE.test(value) || "Код неверный",
        date: (value) => {
          if (!PATTERNS.DATE.test(value)) {
            return "Неверная дата";
          }

          const splittedValue = value.length ? value.split(".") : [];
          const [day = "", month = "", year = ""] = splittedValue;
          const hasBeenFilled =
            day.length === 2 && month.length === 2 && year.length === 4;

          if (splittedValue.length === 3 && hasBeenFilled) {
            const ageDiffMs =
              Date.now() - new Date(this.parseDate(value)).getTime();
            const age = new Date(ageDiffMs);
            return (
              (age.getUTCFullYear() - 1970) >= 18 || "Минимум 18 лет."
            );
          }

          return false;
        },
      },
      cards: [
         {
          text: "Заполни форму",
          arrow,
          icon: tick,
          type: "tick",
        },
        {
          text: "Получи электронную Карту METRO на e-mail",
          arrow,
          icon: card,
          type: "card",
        },
        {
          text: "Совершай покупки в ТЦ&#160;МЕТРО",
          icon: metro,
          type: "metro",
        },
      ],
    };
  },
  methods: {
    async submit() {
      this.isSent = false
      if (this.$refs.form.validate() && this.fields.sms_code) 
      {
        this.fields.newPhone = this.fields.phone
          .replace(/[(\-)]/g, "")
          .replace("+7", "8");
        this.fields.reg = "msk";
        const {
          newPhone: phone,
          email,
          birthDate,
          firstName: name,
          lastName: surname,
          patronymic,
          sms_code,
          recaptcha_response,
          reg,
        } = this.fields;

        this.isLoading = true;
        const params = {
          phone,
          email,
          birthDate,
          name,
          surname,
          patronymic,
          sms_code,
          recaptcha_response,
          reg,
        };
        fetch(`${process.env.VUE_APP_REGISTER_URL}`, {
          headers: { "X-API-KEY": `${process.env.VUE_APP_TOKEN}` },
          method: "POST",
          body: JSON.stringify(params),
        })
          .then((response) => {
            if (response.status == 200) return response.json();
            else return Promise.reject();
          })
          .then((data) => {
            console.log(data);
            this.isLoading = false;
            if (data.data && data.data.result) {
              this.responseStatus = STATUSES.SUCCESS;
              // Success message depending or response type
              if (data.data.action === "new_card") {
                this.formMessage = MESSAGES.SUCCESS.CREATE.replace(
                  "XXXXXX",
                  data.data.barcode
                );
              } else {
                this.formMessage = MESSAGES.SUCCESS.ALREADY_EXIST.replace(
                  "XXXXXX",
                  data.data.barcode
                );
              }
            } else {
              this.responseStatus = STATUSES.ERROR;
              this.formMessage = data.message + ` ${MESSAGES.ERROR.TRY_AGAIN}`;
              this.codeReceived = true;
            }
          })
          .catch(() => {
            this.responseStatus = STATUSES.ERROR;
            this.formMessage = MESSAGES.ERROR.NOT_AVAILABLE;
          })
          .finally(() => {
            this.isDone = true;
          });
      } else {
        this.isSent = true;
        this.responseStatus = STATUSES.ERROR;
        this.formMessage = MESSAGES.ERROR.WRONG_PARAMS;
      }
    },
    async getCode() {
      if (this.fields.phone && this.fields.phone.length == 16) {
        this.fields.newPhone = this.fields.phone
          .replace(/[(\-)]/g, "")
          .replace("+7", "8");

        this.isGettingCode = true;
        this.isSent = false
        await fetch(`${process.env.VUE_APP_SMS_CODE_URL}`, {
          headers: { "X-API-KEY": `${process.env.VUE_APP_TOKEN}` },
          method: "POST",
          body: JSON.stringify({ phone: this.fields.newPhone }),
        })
          .then((response) => {
            if (response.status == 200) return response.json();
            else return Promise.reject();
          })
          .then((data) => {
            console.log(data);
            if (data.data && data.data.result == true) {
              this.responseStatus = STATUSES.SUCCESS;
              this.formMessage = data.message;
              this.codeReceived = true;
            } else {
              this.responseStatus = STATUSES.ERROR;
              this.formMessage = data.message + ` ${MESSAGES.SUCCESS.SMS_SEND}`;
              this.codeReceived = true;
            }
          })
          .catch(() => {
            this.responseStatus = STATUSES.ERROR;
            this.formMessage = MESSAGES.ERROR.NOT_AVAILABLE;
          })
          .finally(() => {
            this.isSent = true;
            this.isGettingCode = false;
          });
      }
    },
    verifyCaptcha(val) {
      this.fields.recaptcha_response = val;
    },
    togglePersDataProcessingText() {
      const prevValue = this.shouldShowPersDataProcessing;
      this.shouldShowPersDataProcessing = !prevValue;
    },
    toggleSmsDetailsText() {
      const prevValue = this.shouldShowSmsDetails;
      this.shouldShowSmsDetails = !prevValue;
    },
    toggleCashbackText() {
      const prevValue = this.shouldShowCashbackDetails;
      this.shouldShowCashbackDetails = !prevValue;
    },
    toggleGuestCardUsageText() {
      const prevValue = this.shouldShowGuestCardUsageDetails;
      this.shouldShowGuestCardUsageDetails = !prevValue;
    },
    onResize() {
      this.isMobile = window.innerWidth <= 770;
    },
    filterInput(event) {
      const { value, name } = event.target;
      const matchedValue = value.match(PATTERNS.CYRILLIC);
      const matchedPrevValue = this.fields[name].match(PATTERNS.CYRILLIC);
      const canUpdateValue =
        matchedValue && matchedValue[0].length === value.length;
      this.fields[name] = canUpdateValue
        ? value
        : matchedPrevValue
        ? matchedPrevValue[0]
        : "";
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  computed: {
    computedDateFormatted: {
      get: function () {
        return this.formatDate(this.fields.birthDate);
      },
      set: function (v) {
        this.fields.birthDateFormatted = v;
      },
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });

    const fields = localStorage.getItem("form-fields");

    if (fields) {
      this.fields = JSON.parse(fields);
    }
  },
  watch: {
    fields: {
      handler: (fields) => {
        const {
          phone,
          email,
          birthDate,
          firstName,
          lastName,
          patronymic      
        } = fields;
        localStorage.setItem("form-fields", JSON.stringify({phone, email, birthDate, firstName, lastName, patronymic}));
      },
      deep: true,
    },
    "fields.birthDate"() {
      this.fields.birthDateFormatted = this.formatDate(this.fields.birthDate);
    },
    dateMenu(val) {
      val && setTimeout(() => (this.$refs.datePicker.activePicker = "YEAR"));
    },
  },
};
</script>

<style>
.form-card {
  border-radius: 10px !important;
  padding: 15px;
}

.form-card__title {
  color: #004282;
  text-transform: uppercase;
  font-size: 1.6rem;
  font-weight: 800;
  word-break: normal;
}

.submit-button {
  background-color: #004282 !important;
  border-radius: 30px !important;
  text-transform: none !important;
  margin-bottom: 10px;
  color: #ffe800 !important;
  font-size: 1rem !important;
}

.code-button {
  width: 100%;
  text-transform: none !important;
  background-color: #ffe600 !important;
  font-size: 1rem !important;
}

.captcha-wrapper {
  text-align: -webkit-center;
}

.pers-data__title,
.pers-data__text,
.details__title,
.details__text {
  font-size: 11px;
  color: #004282;
}

.pers-data__text,
.details__text {
  text-align: justify;
}

.pers-data__link {
  font-size: 11px;
}

.adv-checkbox label {
  color: #004282 !important;
  text-align: justify;
}

.details__title {
  font-size: 13px;
  text-align: left;
  display: block;
  text-decoration: underline;
  font-weight: 500;
}

@media screen and (max-width: 420px) {
  .form-card__title {
    font-size: 18px;
  }
}

@media screen and (max-width: 600px) {
  .submit-button {
    max-width: 250px;
    font-size: 11px !important;
  }
}
</style>
